import React, { useState } from "react";
import { Toast } from "../services/toast-service";
import { Auth } from "aws-amplify";
import { useNavigate, Link } from "react-router-dom";

type SignUpScreenProps = {};

const SignUpScreen: React.FC<SignUpScreenProps> = (props) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();

  const handleSignUp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    if (password !== confirmPassword) {
      Toast(
        "Error!!",
        "Password and Confirm Password should be same",
        "danger"
      );
      return;
    }
    try {
      await Auth.signUp({
        username: email,
        password: confirmPassword,
        attributes: {
          email,
          name,
        },
      });
      Toast("Success!!", "Signup was successful", "success");
      navigate("/confirmation");
    } catch (err) {
      console.error(err);
      if (err instanceof Error) {
        Toast("Error!!", err.message, "danger");
      } else {
        Toast("Error!!", "Something went wrong during sign up.", "danger");
      }
    }
    setLoading(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const name = e.target.name;
    if (name === "email") {
      setEmail(value);
    } else if (name === "password") {
      setPassword(value);
    } else if (name === "name") {
      setName(value);
    }
  };

  return (
    <form onSubmit={handleSignUp}>
      <h1>New account registration</h1>
      <input
        placeholder="Name"
        type="text"
        name="name"
        value={name}
        onChange={handleInputChange}
      />
      <input
        placeholder="Email"
        type="email"
        name="email"
        value={email}
        onChange={handleInputChange}
      />
      <input
        placeholder="Password"
        type="password"
        name="password"
        value={password}
        onChange={handleInputChange}
      />
      <button disabled={loading}>
        {loading && <span>loading</span>}
        Sign up
      </button>
      <Link to="/login">go to login &rarr;</Link>
    </form>
  );
};

export default SignUpScreen;
